




























import { Component, Prop, Vue } from "vue-property-decorator";
import i18n from "@/i18n";

    @Component
export default class AddResourceMenu extends Vue {
    // lifecycle hooks

    // computed
    get title() {
        return i18n.t("acl.addResource");
    }

    // methods
    openResourcePrompt(resource: string) {
        this.$emit("openResourcePrompt", resource);
    }
}
